<template>
    <div>
        <v-row class="sector-head">
            <v-col class="primary_blue--text subtitle-1 flex-sm-nowrap font-weight-bold" cols="5" md="6">
                <p class="mb-0">Líneas de {{invoice.name}}</p>
            </v-col>

            <v-col class="d-flex justify-end align-center flex-sm-nowrap" cols="7" md="6">
                <v-progress-circular v-if="loading" indeterminate class="mr-2" color="primary"></v-progress-circular>

                <v-btn outlined class="mr-2" small color="primary" @click="ImportLinesFromExcel()"
                :disabled="!allow_import || loading">
                    <AppIcon :src="require('../assets/upload_excel.svg')" :size="29" />
                    <span v-if="!is_mobile"> Subir Excel </span>
                </v-btn>

                <v-btn color="primary" outlined small class="mr-2" @click="openDialogAdditionalInfo()" :disabled="loading">
                    <AppIcon :src="require('../assets/add_info.svg')" :size="29" />
                    <span v-if="!is_mobile"> Información adicional </span>
                </v-btn>

                <v-btn color="primary" outlined small class="mr-2" @click="openDialogDeleteAllLines()" :disabled="readonly || loading">
                    <v-icon>mdi-delete</v-icon>
                    <span v-if="!is_mobile"> Borrar todas las líneas </span>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="error__msg"
            v-if="showErrors && !areInvoiceLinesValid">
            <v-col cols=12>
                <!-- Para poder [firmar y emitir la factura]/[emitir el {{ invoice.name }}], -->
                <!-- es necesario rellenar el/los campo/s "Descripción"["Precio Unitario" y "Cantidad"] en las líneas de {{ invoice.name }}. -->
                {{messageLinesError}}
            </v-col>
        </v-row>
        <v-card flat width="100%" class="text-center lines__table" style="overflow-y:scroll">

            <v-row class="table-head-row flex-sm-nowrap d-flex align-center justify-center" no-gutters v-if="!is_mobile">
                <v-col :cols="invoiceable_type == 'invoice' ? (some_0_tax ? 5 : 6) : (some_0_tax ? 6 : 7)">Descripci&oacute;n</v-col>
                <v-divider vertical/>
                <div class="col" cols="1">Precio Unitario</div>
                <v-divider vertical/>
                <div class="col" cols="1">Cantidad</div>
                <v-divider vertical/>

                <template v-if="showLineDiscount">
                    <div class="col" cols="1">{{ line_discount_type === '%' ? 'Descuento %' : 'Descuento €' }}</div>
                    <v-divider vertical/>
                </template>

                <div class="col" cols="1">{{computed_tax_type.toUpperCase()}}</div>
                <v-divider vertical/>
                <div v-if="some_0_tax" class="col" cols="1">Tipo</div>
                <v-divider v-if="some_0_tax" vertical/>
                <div class="col" cols="1">Retención</div>
                <v-divider vertical/>
                <div class="col" cols="1">Importe total (sin IVA/IGIC)</div>
                <!-- Additional fields from productConfiguration -->
                <template v-if="got_feature('feature_add_columns_to_e_invoice') && productConfiguration && productConfiguration.fields">
                    <span v-for="field in productConfiguration.fields" :key="field.key" style="display: contents;">
                        <v-divider vertical/>
                        <div class="col" style="min-width: 100px; max-width: 100px;">{{ field.name }}</div>
                    </span>
                </template>
                
                <v-divider vertical/>
                <div class="col" cols="1">Importe total</div>
                
                <v-divider vertical/>
                <div class="col small_col">Más datos</div>
            </v-row>

            <div no-gutters v-for="(invoice_line, index) in invoice_lines" v-bind:key="index" v-if="!is_mobile">
                <div class="d-flex flex-sm-nowrap table-row">
                    <template>
                        <v-col :cols="invoiceable_type == 'invoice' ? (some_0_tax ? 5 : 6) : (some_0_tax ? 6 : 7)" class=" pa-0 ma-0 d-flex flex-sm-nowrap ">
                            <div class="d-flex align-center justify-center">
                                <v-btn icon color="#4c4c4c" @click="deleteInvoiceLine(index)" :disabled="readonly">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                            <v-divider vertical/>
                            <div class="d-flex align-center justify-center px-2"
                                :class="index % 2 == 0 ? 'bg__gray__2' : 'bg__gray'">
                                {{ (index + 1) }}
                            </div>
                            <v-divider vertical/>
                            <v-combobox filled dense flat solo background-color="white"
                                v-model="invoice_line.description" :items="rest_products" item-text="code"
                                hide-details return-object :readonly="readonly" :filter="filterProducts"
                                @blur="(event) => product_changed(event.target.value, index)"
                                @change="(product) => product_changed(product, index)">
                                <!-- Si se pone esta linea se rompen los filtros, comentar con Jessica -->
                                <!-- @update:search-input="(query) => product_changed(query, index)"> -->
                                <template v-slot:item="data">
                                    {{ `(${data.item.code}) - ${data.item.description}` }}
                                </template>
                            </v-combobox>
                        </v-col>
                    </template>
                    <v-divider vertical/>
                    <div class="col">
                        <TableCustomTextField v-model="invoice_line.unit_price_without_tax" :required="true"
                            @input="change(index)" :readonly="readonly" :reverse="true" :type="'number'">
                        </TableCustomTextField>
                    </div>
                    <v-divider vertical/>
                    <div class="col">
                        <TableCustomTextField @input="change(index)" :required="true" v-model="invoice_line.quantity"
                            :readonly="readonly" :reverse="true" :type="'number'"></TableCustomTextField>
                    </div>
                    <v-divider vertical/>

                    <template v-if="showLineDiscount && invoice_line.discounts.length>0">
                        <div class="col">
                            <TableCustomTextField v-if="line_discount_type === '%'" @input="change(index)" v-model.number="invoice_line.discounts[0].rate"
                                :readonly="readonly" :reverse="true" :type="'number'"></TableCustomTextField>
                            <TableCustomTextField v-else @input="change(index)" v-model.number="invoice_line.discounts[0].amount"
                                :readonly="readonly" :reverse="true" :type="'number'"></TableCustomTextField>
                        </div>
                        <v-divider vertical/>
                    </template>

                    <div class="col">
                        <v-autocomplete autocomplete="off" filled dense flat solo background-color="white"
                            :value="invoice_line.selected_tax" :items="computed_tax_items" item-text="name" item-value="value"
                            :return-object="false" hide-details :readonly="readonly" style="width: 100%"
                            @change="(newRate) => tax_change(newRate, index)"></v-autocomplete>
                    </div>
                    <v-divider vertical/>
                    <div class="col" v-if="some_0_tax">
                        <v-tooltip bottom :disabled="isValidTaxEvent(invoice_line.selected_tax_event)">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">
                                    <v-autocomplete v-if="invoice_line.selected_tax==0.0"
                                        autocomplete="off" filled dense flat solo background-color="white" :value="invoice_line.selected_tax_event"
                                        :items="type_0_options" :readonly="readonly"
                                        :error="!isValidTaxEvent(invoice_line.selected_tax_event)"
                                        hide-details
                                        @change="(newTaxEvent) => tax_event_change(newTaxEvent, index)"></v-autocomplete>
                                </div>
                            </template>
                            <span>{{ taxEventErrorMessage }}</span>
                        </v-tooltip>
                    </div>
                    <v-divider  v-if="some_0_tax" vertical/>
                    <div class="col">
                        <v-autocomplete autocomplete="off" filled dense flat solo background-color="white"
                            :value="invoice_line.selected_retention" :items="line_retentions" item-text="name"
                            item-value="value" :return-object="false" hide-details :readonly="readonly"
                            @change="(newRate) => retention_change(newRate, index)"></v-autocomplete>

                    </div>
                    <v-divider vertical/>
                    <div class="col">
                        <TableCustomTextField :value="invoice_line.gross_amount" readonly :reverse="true">
                        </TableCustomTextField>
                    </div>
                    <!-- Additional fields from productConfiguration -->
                    <template v-if="got_feature('feature_add_columns_to_e_invoice') && productConfiguration && productConfiguration.fields">
                        <span v-for="field in productConfiguration.fields" :key="field.key" style="display: contents;">
                            <v-divider vertical/>
                            <div class="col" style="min-width: 100px; max-width: 100px;">
                                <TableCustomTextField 
                                    :value="getAdditionalFieldValue(invoice_line, field.key)"
                                    @input="updateAdditionalFieldValue(invoice_line, field.key, $event); change(index)"
                                    :readonly="readonly"
                                    :reverse="true"
                                />
                            </div>
                        </span>
                    </template>
                    <v-divider vertical/>
                    <div class="col">
                        <TableCustomTextField :value="get_total_amount(invoice_line)" readonly :reverse="true">
                        </TableCustomTextField>
                    </div>
                    
                    
                    <v-divider vertical/>
                    <div class="col small_col">
                        <v-btn icon @click="openDialogOtherInformation(invoice_line)">
                            <AppIcon :src="require('@/assets/folder_info.svg')" :size="24" :colorMap="{ '060647': 'primary_blue' }"/>
                        </v-btn>
                    </div>
                </div>
                <v-divider/>
            </div>
            <v-row class="pa-3" v-if="is_mobile">
                <v-col cols="12">
                    <v-card outlined>
                        <v-card-text>
                            <v-row no-gutters class="table-head-row flex-nowrap">
                                <v-col cols="5" class="table-head">Descripci&oacute;n</v-col>
                                <v-divider vertical/>
                                <v-col class="table-head" cols="3">Cantidad</v-col>
                                <v-divider vertical/>
                                <v-col cols="4" class=" table-head " >Importe total</v-col>
                            </v-row>
                            <v-row no-gutters v-for="(invoice_line, index) in invoice_lines" v-bind:key="index" @click="openDialogEditLine(invoice_line, index)">
                                <v-col cols="1" class="pa-0 d-flex align-center justify-center" :class="index % 2 == 0 ? 'bg__gray__2' : 'bg__gray'">
                                    {{ (index + 1) }}
                                </v-col>
                                <v-col cols="4" class=" pa-0 ma-0 d-flex flex-sm-nowrap">
                                    <TableCustomTextField
                                        :required="true"
                                        v-model="invoice_line.description"
                                        :kind="'invoice_line_kind'"
                                        readonly
                                    />
                                </v-col>
                                <v-divider vertical/>
                                <v-col cols="3">
                                    <TableCustomTextField
                                        @change="change(index)"
                                        :required="true"
                                        v-model="invoice_line.quantity"
                                        readonly
                                        :reverse="true"
                                        :type="'number'"
                                    />
                                </v-col>
                                <v-divider vertical/>
                                <v-col  class="pa-0">
                                    <TableCustomTextField
                                        :value="get_total_amount(invoice_line)"
                                        readonly
                                        :reverse="true"
                                    />
                                </v-col>
                            </v-row>
                            <v-divider/>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog v-model="showAdditionalInfoDilog" max-width="880">
                <v-card>
                    <v-card-title class="headline">
                        <span class="text-h5 primary__blue py-1 ml-2" color="">Información adicional</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-5 pb-5">
                        <v-tabs
                        v-model="additionalInfoActiveTab"
                        background-color="transparent"
                        color="primary"
                        class="card__tabs px-5"
                        >
                            <v-tab v-for="tab in additionalInfoTabs" :key="tab.code" class="text-capitalize" v-on="{ click: () => additionalInfoActiveTab = tab.code }">
                                {{ tab.name }}
                            </v-tab>
                        </v-tabs>
                        <v-divider></v-divider>
                        <v-tabs-items v-model="additionalInfoActiveTab">
                            <v-tab-item v-for="tab in additionalInfoTabs" :key="tab.code">
                                <template v-if="tab.code == 'retention'">
                                    <app-row class="mt-5" contains-input-fields>
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Concepto de retención</label>
                                            <v-text-field type="text" outlined dense hide-details v-model="ret_concept"
                                                :readonly="readonly"></v-text-field>
                                        </app-col>
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Importe de retención</label>
                                            <v-text-field type="number" outlined dense hide-details v-model="ret_amount"
                                                :readonly="readonly"></v-text-field>
                                        </app-col>
                                    </app-row>
                                    <app-row contains-input-fields>
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Concepto de suplido</label>
                                            <v-text-field type="text" outlined dense hide-details v-model="reimbursable_expense_concept"
                                                :readonly="readonly"></v-text-field>
                                        </app-col>
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Suplido</label>
                                            <v-text-field type="number" outlined dense hide-details v-model="reimbursable_expense"
                                                :readonly="readonly"></v-text-field>
                                        </app-col>
                                    </app-row>
                                </template>

                                <template v-if="tab.code == 'discounts'">
                                    <app-row class="mt-5" contains-input-fields>
                                        <div class="d-flex align-center">
                                            <v-checkbox
                                                class="ma-0 pl-2 pt-0"
                                                v-model="checkedLineDiscount"
                                                :disabled="readonly || checkedGlobalDiscount"
                                                hide-details
                                            >
                                                <template v-slot:label>
                                                    <span class="text-field-size">Descuento por línea</span>
                                                </template>
                                            </v-checkbox>
                                            <v-btn-toggle v-if="checkedLineDiscount" v-model="line_discount_type" mandatory dense class="ml-4">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn value="%" small :disabled="readonly" v-bind="attrs" v-on="on">%</v-btn>
                                                    </template>
                                                    <span>Porcentaje</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn value="net" small :disabled="readonly" v-bind="attrs" v-on="on">€</v-btn>
                                                    </template>
                                                    <span>Importe fijo</span>
                                                </v-tooltip>
                                            </v-btn-toggle>
                                        </div>
                                    </app-row>
                                    <app-row contains-input-fields>
                                        <v-checkbox
                                            class="ma-0 pl-2"
                                            v-model="checkedGlobalDiscount"
                                            :disabled="readonly || checkedLineDiscount"
                                        >
                                            <template v-slot:label>
                                                <span class="text-field-size">Descuento global</span>
                                            </template>
                                        </v-checkbox>
                                    </app-row>

                                    <app-row contains-input-fields v-if="checkedGlobalDiscount">
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Cantidad descuento</label>
                                            <v-text-field type="number" outlined dense hide-details v-model="discount_amount"
                                                :readonly="readonly"></v-text-field>
                                        </app-col>
                                        <app-col contains-input-fields cols="6">
                                            <label class="text-no-wrap">Concepto de descuento</label>
                                            <v-text-field type="text" outlined dense v-model="discount_reason"
                                                :readonly="readonly"
                                                :rules="discountReasonRules"
                                                :error-messages="showDiscountReasonError && !discount_reason ? 'El campo es obligatorio' : ''"
                                                :hide-details="!discount_amount && !showDiscountReasonError"
                                                @input="showDiscountReasonError = false"></v-text-field>
                                        </app-col>
                                    </app-row>
                                </template>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>
                    <v-card-actions class="pr-8 pb-5">
                        <v-spacer></v-spacer>
                        <v-btn outlined @click="cancelChange()" class="action__btn">Cancelar</v-btn>
                        <v-btn color="primary_blue" class="white--text action__btn" @click="changeAdditionalInfo()"
                            :disabled="readonly">
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="showEditLineDialog" max-width="880">
                <v-card>
                    <v-card-title class="headline">
                        <span class="text-h5 primary__blue py-1 ml-2" color="">Editar la l&iacute;nea {{ num_line + 1 }}</span>
                        <v-spacer/>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn  color="primary_blue" @click="tryDelete()" icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Eliminar línea</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text class="pt-5 pb-5">
                        <app-row contains-input-fields>
                            <app-col contains-input-fields cols="6">
                                <label class="text-no-wrap">Descripción</label>
                                <v-combobox outlined filled dense flat solo background-color="white"
                                    :value="line['description']" :items="rest_products" item-text="description"
                                    hide-details return-object :readonly="readonly" :filter="filterProducts"
                                    @change="(product) => product_changed(product, num_line)">
                                    <template v-slot:item="data">
                                        {{ `(${data.item.code}) - ${data.item.description}` }}
                                    </template>
                                </v-combobox>
                            </app-col>
                            <!-- <app-col v-else cols="6">
                                <label class="text-no-wrap">Descripción</label>
                                <v-text-field outlined dense hide-details :required="true" v-model="line['description']"
                                    :kind="'invoice_line_kind'" :readonly="readonly"
                                />
                            </app-col> -->
                            <app-col contains-input-fields cols="6">
                                <label class="text-no-wrap">Precio Unitario</label>
                                <v-text-field outlined dense hide-details v-model="line['unit_price_without_tax']" :required="true"
                                   :readonly="readonly" :reverse="true" type="number"
                                />
                            </app-col>
                        </app-row>
                        <app-row contains-input-fields>
                            <app-col contains-input-fields cols="6">
                                <label class="text-no-wrap">Cantidad</label>
                                <v-text-field outlined dense hide-details :required="true" v-model="line['quantity']"
                                    :readonly="readonly" :reverse="true" type="number"
                                />
                            </app-col>
                            <app-col contains-input-fields cols="6">
                                <label class="text-no-wrap">{{computed_tax_type.toUpperCase()}}</label>
                                <v-autocomplete
                                    autocomplete="off" outlined filled dense flat solo background-color="white"
                                    :value="line['selected_tax']" :items="computed_tax_items" item-text="name" item-value="value"
                                    :return-object="false" hide-details :readonly="readonly"
                                    @change="(newRate) => tax_change(newRate, num_line)"
                                />
                            </app-col>
                        </app-row>
                        <app-row contains-input-fields>
                            <app-col contains-input-fields cols="6">
                                <label class="text-no-wrap">Retención</label>
                                <v-autocomplete
                                    autocomplete="off" outlined filled dense flat solo background-color="white"
                                    :value="line['selected_retention']" :items="line_retentions" item-text="name"
                                    item-value="value" :return-object="false" hide-details :readonly="readonly"
                                    @change="(newRate) => retention_change(newRate, num_line)"
                                />
                            </app-col>
                            <app-col contains-input-fields cols="6" v-if="line['selected_tax']==0.0">
                                <label class="text-no-wrap">Tipo</label>
                                <v-tooltip bottom :disabled="isValidTaxEvent(line['selected_tax_event'])">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <v-autocomplete
                                                autocomplete="off" outlined filled dense flat solo background-color="white" :value="line['selected_tax_event']"
                                                :items="type_0_options" :readonly="readonly"
                                                :error="!isValidTaxEvent(line['selected_tax_event'])"
                                                hide-details
                                                @change="(newTaxEvent) => tax_event_change(newTaxEvent, num_line)"
                                            />
                                        </div>
                                    </template>
                                    <span>{{ taxEventErrorMessage }}</span>
                                </v-tooltip>
                            </app-col>

                        </app-row>
                    </v-card-text>
                    <v-card-actions class="px-8 pb-5">
                        <v-btn outlined @click="cancelEditLineChange()" class="action__btn">Cancelar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary_blue" class="white--text action__btn" @click="changeInvoiceLine(num_line)"
                            :disabled="readonly || (line['selected_tax']==0.0 && !isValidTaxEvent(line['selected_tax_event']))"
                        >
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>

        <v-dialog v-model="delete_pop_up" persistent max-width="500">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text prevent-cut">¿Est&aacute;s seguro de que quieres eliminar la l&iacute;nea {{ num_line + 1}}?</span>
                </v-card-title>
                <v-card-actions class="acction_btns">
                    <v-btn outlined @click="delete_pop_up = false" class="action__btn">Cancelar</v-btn>
                    <v-spacer/>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="deleteInvoiceLine(num_line)"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="d-flex mt-4 ml-4">
            <v-btn outlined small v-on="{ click: addInvoiceLine }" :disabled="readonly || loading">
                <v-icon v-once> mdi-plus </v-icon>
                Añadir línea
            </v-btn>
        </div>

        <v-dialog v-model="otherInformationDialog" max-width="1000"  class="pa-0 ma-0 rounded-lg" persistent :key="keyDialog">
            <v-card style="max-height: 1000px; height: 100%; overflow-y: auto;">
                <v-card-title class="more__info__editor__title">
                    <span>Otros datos</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-0 py-5">

                    <!-- <app-row contains-input-fields class="px-16">
                        <app-col contains-input-fields cols="4">
                            <label class="text-no-wrap">Número de albarán</label>
                            <v-text-field outlined dense hide-details v-model="delivery_note_number"
                                :readonly="readonly"></v-text-field>
                        </app-col>
                        <app-col contains-input-fields cols="4">
                            <label class="text-no-wrap">Fecha de albarán</label>
                            <AppDateField
                                v-model="delivery_note_date"
                                :disabled="readonly"
                            />
                        </app-col>
                        <app-col contains-input-fields cols="12">
                            <label class="text-no-wrap">Información Adicional</label>
                            <v-textarea outlined dense hide-details v-model="additional_line_information"
                                :readonly="readonly"></v-textarea>
                        </app-col>
                    </app-row> -->

                    <v-tabs
                        v-model="activeTab"
                        background-color="transparent"
                        color="primary"
                        class="card__tabs px-5 pt-5"
                    >
                        <v-tab v-for="tab in tabs" :key="tab.code" class="text-capitalize" v-on="{ click: () => activeTab = tab.code }">
                            {{ tab.name }}
                        </v-tab>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-tabs-items v-model="activeTab">
                        <v-tab-item v-for="tab in tabs" :key="tab.code">
                            <app-row v-show="tab.code == 'delivery_note'" contains-input-fields class="px-16 py-5">
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Número Albarán</label>
                                    <v-text-field outlined dense hide-details v-model="delivery_note_number"
                                :readonly="readonly"></v-text-field>
                                </app-col>
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Fecha de albarán</label>
                                    <AppDateField
                                        v-model="delivery_note_date"
                                        :disabled="readonly"
                                    />
                                </app-col>
                            </app-row>

                            <app-row v-show="tab.code == 'sender'" contains-input-fields class="px-16 py-5">
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Número de
                                        <span v-if="invoice.related_invoiceables_type == 'proforma'">proforma</span>
                                        <span v-else>presupuesto</span>
                                    </label>
                                    <v-text-field outlined dense hide-details v-model="sender_info.budget_number"
                                        :readonly="readonly"></v-text-field>
                                </app-col>
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Fecha de
                                        <span v-if="invoice.related_invoiceables_type == 'proforma'">proforma</span>
                                        <span v-else>presupuesto</span>
                                    </label>
                                    <AppDateField
                                        v-model="sender_info.budget_date"
                                        :disabled="readonly"
                                    />
                                </app-col>
                            </app-row>
                            <app-row v-show="tab.code == 'receiver'" contains-input-fields class="px-16 py-5">
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Referencia Cliente</label>
                                    <v-text-field outlined dense hide-details v-model="receiver_info.budget_number"
                                        :readonly="readonly"></v-text-field>
                                </app-col>
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Fecha de Referencia Cliente</label>
                                    <AppDateField
                                        v-model="receiver_info.budget_date"
                                        :disabled="readonly"
                                    />
                                </app-col>
                            </app-row>

                            <app-row v-show="tab.code == 'record'" contains-input-fields class="px-16 py-5">
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Referencia Expediente</label>
                                    <v-text-field outlined dense hide-details v-model="record_reference"
                                        :readonly="readonly"></v-text-field>
                                </app-col>
                                <app-col contains-input-fields cols="6">
                                    <label class="text-no-wrap">Fecha de Referencia Expediente</label>
                                    <AppDateField
                                        v-model="record_reference_date"
                                        :disabled="readonly"
                                    />
                                </app-col>
                            </app-row>

                            <app-row v-show="tab.code == 'additional_line_information'" contains-input-fields class="px-16 py-5">
                                <app-col contains-input-fields cols="12">
                                    <label class="text-no-wrap">Infromación Adicional</label>
                                    <v-textarea outlined dense hide-details v-model="additional_line_information"
                                        :readonly="readonly" rows="9">
                                    </v-textarea>
                                </app-col>
                            </app-row>
                        </v-tab-item>
                    </v-tabs-items>

                </v-card-text>
                <v-card-actions class="pb-5 d-flex justify-center">
                    <v-btn outlined @click="otherInformationDialog=false" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn"
                        :disabled="readonly" @click="chnageOtherInformation()">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import TableCustomTextField from "../components/layout/TableCustomTextField.vue"
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import { mapGetters } from "vuex";
import { AdditionalInformation, ExtraAmount, ReceiverInfo, SenderInfo } from '../modules/facturae/domain/Invoiceable'
import { getValidTaxEventOptions } from '../modules/facturae/domain/InvoiceableValidation'
import { Product } from "@/modules/facturae/domain/Product";
import AppDateField from "@/modules/widgets/infra/AppDateField.vue";

export default {
    name: "InvoiceLinesEditor",
    components: {
        AppRow,
        AppCol,
        TableCustomTextField,
        AppDateField
    },

    props: {
        invoice_lines: {
            type: Array,
            required: true
        },
        allow_import: {
            type: Boolean,
            required: false,
            default: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        invoice: {
            type: Object,
            required: false,
        },
        products: {
            type: Array,
            required: false,
        },
        showErrors: {
            type: Boolean,
            required: false,
            default: false
        },
        tax_type:{
            type: String,
            required: false,
            default: 'iva/igic'
        },
        invoiceable_type: {
            type: String,
            required: false,
            default: 'invoice'
        },
        isRecurringContract: {
            type: Boolean,
            required: false,
            default: false
        },
        productConfiguration: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data() {
        return {
            showAdditionalInfoDilog: false,
            showEditLineDialog:false,
            ret_amount: undefined,
            ret_concept: undefined,
            line: {},
            checkedLineDiscount: false,
            checkedGlobalDiscount: false,
            discount_reason: undefined,
            discount_amount: undefined,
            showDiscountReasonError: false,
            reimbursable_expense: undefined,
            reimbursable_expense_concept: undefined,
            num_line: undefined,
            delete_pop_up: false,
            line_retentions: [
                { name: 'N/A', value: 'na' },
                { name: '1%', value: 0.01 },
                { name: '7%', value: 0.07 },
                { name: '15%', value: 0.15 },
                { name: '19%', value: 0.19 },
            ],
            rest_products: this.products,
            otherInformationDialog: false,
            keyDialog: 0,
            sender_info: new SenderInfo(),
            receiver_info: new ReceiverInfo(),
            delivery_note_number: '',
            delivery_note_date: '',
            additional_line_information: '',
            record_reference: '',
            record_reference_date: '',
            // tabs: [
            //     {code: "delivery_note", "name": "Albarán"},
            //     {code: "sender", "name": "Refs. Emisor"},
            //     {code: "receiver", "name": "Refs. Receptor"},
            //     {code: "additional_line_information", "name": "Información Adicional"}
            // ],
            activeTab: 'receiver',
            additionalInfoTabs: [
                {code: "retention", "name": "Retención"},
                {code: "discounts", "name": "Descuentos"}
            ],
            additionalInfoActiveTab: 'retention',
            actualOtherInformationLine: undefined,
            line_discount_type: '%',
            isLoadingDiscounts: false

        }
    },
    watch: {
        invoice_lines: {
            immediate: true,
            handler(lines) {
                if (!lines || lines.length === 0) return;
                this.isLoadingDiscounts = true;
                for (let line of lines) {
                    if (line.discounts && line.discounts.length > 0) {
                        if (line.discounts[0].rate > 0) {
                            this.checkedLineDiscount = true;
                            this.line_discount_type = '%';
                            break;
                        } else if (line.discounts[0].amount > 0) {
                            this.checkedLineDiscount = true;
                            this.line_discount_type = 'net';
                            break;
                        }
                    }
                }
                this.$nextTick(() => {
                    this.isLoadingDiscounts = false;
                });
            }
        },
        checkedGlobalDiscount(newVal) {
            if (!newVal) {
                this.discount_amount = undefined;
                this.discount_reason = undefined;
            }
        },
        checkedLineDiscount(newVal) {
            // When the line discount is disabled, clear the discounts of all lines
            if (!newVal) {
                this.invoice_lines.forEach((line, i) => {
                    if (line.discounts && line.discounts.length > 0) {
                        line.discounts = [];
                        this.$emit('change-line', i);
                    }
                });
            }
        },
        line_discount_type() {
            if (this.isLoadingDiscounts) return;
            for (let line of this.invoice_lines) {
                if (line.discounts && line.discounts.length > 0) {
                    line.discounts[0].rate = 0;
                    line.discounts[0].amount = 0;
                }
            }
        }
    },
    computed: {
        discountReasonRules(){
            if (this.discount_amount) {
                return [v => !!v || 'El campo es obligatorio'];
            }
            return [];
        },
        taxEventErrorMessage(){
            const taxType = this.computed_tax_type.toUpperCase();
            return `El tipo es obligatorio para ${taxType} 0%`;
        },
        tabs(){
            if (this.invoiceable_type === 'invoice'){
                return [
                    {code: "delivery_note", "name": "Albarán"},
                    {code: "sender", "name": "Refs. Emisor"},
                    {code: "receiver", "name": "Refs. Receptor"},
                    {code: 'record', 'name': "Refs. Expediente"},
                    {code: "additional_line_information", "name": "Información Adicional"},
                ];
            }else{
                return [{code: "additional_line_information", "name": "Información Adicional"}];
            }
        },

        ...mapGetters({
            got_feature: 'got_feature',
            is_mobile: 'is_mobile',
        }),
        computed_tax_type(){
            return this.tax_type;
        },
        computed_tax_items(){
            let tax_items = [{ name: '0%', value: 0.00 },{ name: '5%', value: 0.05 } ];
            if(this.computed_tax_type.includes('iva')){
                tax_items.push({ name: '21%', value: 0.21 });
                tax_items.push({ name: '10%', value: 0.10 });
                tax_items.push({ name: '4%', value: 0.04 });
                tax_items.push({ name: '21% RE 5.2%', value: 0.052 });
                tax_items.push({ name: '10% RE 1.4%', value: 0.014 });
                tax_items.push({ name: '4% RE 0.5%', value: 0.005 });
            }
            if(this.computed_tax_type.includes('igic')){
                tax_items.push({ name: '20%', value: 0.2 });
                tax_items.push({ name: '15%', value: 0.15 });
                tax_items.push({ name: '7%', value: 0.07 });
                tax_items.push({ name: '3%', value: 0.03 });

            }
            return tax_items;

        },
        some_0_tax(){
            return this.invoice_lines.some(line => line.selected_tax == 0.0);
        },
        type_0_options(){
            return getValidTaxEventOptions(this.computed_tax_type);
        },

        showLineDiscount() {
            for (const line of this.invoice_lines) {
                if (line.discounts && line.discounts.length > 0)
                    return true;
            }
            return false
        },
        isReimbursableExpense(){
            if (this.reimbursable_expense_concept || this.reimbursable_expense){
                return true;
            }
            return false;
        },
        areInvoiceLinesValid(){
            let feat_lines_0 = this.got_feature('feature_facturae_allow_lines_at_zero')
            for (let i=0; i<this.invoice_lines.length; i++){
                if (!this.isReimbursableExpense){
                    if (!this.invoice_lines[i].iamvalid(feat_lines_0)){
                        return false
                    }
                }
                // Validate that the tax event is informed when IVA/IGIC is 0%
                if (this.invoice_lines[i].selected_tax == 0.0) {
                    if (!this.isValidTaxEvent(this.invoice_lines[i].selected_tax_event)) {
                        return false
                    }
                }
            }
            return true
        },
        messageLinesError() {
            // Para poder [empezar el contrato]/[firmar y emitir la factura]/[emitir el 'this.invoice.name'], <- text0
            // es necesario rellenar [el campo 'Descripción']/[los campos 'Descripción', 'Precio Unitario' y 'Cantidad'] en las líneas de 'this.invoice.name'. <- text1

            let text0
            if (this.$attrsisRecurringContract) {
                text0 = "empezar el contrato"
            }
            else if (this.invoiceable_type == 'invoice') {
                text0 = "firmar y emitir la factura"
            }
            else {
                text0 = "emitir el " + this.invoice.name
            }

            let text1
            if (this.got_feature('feature_facturae_allow_lines_at_zero')) {
                text1 = "el campo 'Descripción'"
            }
            else {
                text1 = "los campos 'Descripción', 'Precio Unitario' y 'Cantidad'"
            }

            // Check if there are lines with IVA/IGIC 0% without tax event informed
            let hasMissingTaxEvent = false
            for (let i=0; i<this.invoice_lines.length; i++){
                if (this.invoice_lines[i].selected_tax == 0.0 && !this.isValidTaxEvent(this.invoice_lines[i].selected_tax_event)) {
                    hasMissingTaxEvent = true
                    break
                }
            }
            if (hasMissingTaxEvent) {
                const taxType = this.computed_tax_type.toUpperCase()
                text1 += ` y el campo 'Tipo' para las líneas con ${taxType} 0%`
            }

            return "Para poder " + text0 + ", es necesario rellenar " + text1 + " en las líneas de " + this.invoice.name + "."
        },
    },
    methods: {
        alternateGray(index) {
            return index % 2 == 1 ? 'background-color: #eeeeee' : 'var(--v-neutralDark-base)';
        },
        deleteInvoiceLine(index) {
            this.$emit('delete-line', index);
            if (this.is_mobile) {
                this.delete_pop_up = false;
                this.showEditLineDialog = false;
            }
        },
        tryDelete(){
            let allow = true;
            if (allow){
                this.delete_pop_up = true;
            }

        },
        change(index) {
            this.$emit('change-line', index);
        },
        get_total_amount(invoice_line) {
            let gross = invoice_line.gross_amount;
            if (invoice_line.discounts.length > 0) {
                if (invoice_line.discounts[0].rate > 0) {
                    gross -= gross * invoice_line.discounts[0].rate / 100;
                } else if (invoice_line.discounts[0].amount > 0) {
                    gross -= invoice_line.discounts[0].amount;
                }
            }
            let tax_amount = gross * invoice_line.taxes[0].rate;
            let recargo = 0;
            //console.log(invoice_line.taxes[0])
            if (invoice_line.taxes[0].recargo_amount) {
                recargo = invoice_line.taxes[0].recargo_amount;
            }
            let withheld_amount = 0;
            if (invoice_line.taxes_withheld.length) {
                withheld_amount = invoice_line.taxes_withheld[0].amount
            }
            return (gross + tax_amount + recargo - withheld_amount).toFixed(2);
        },
        addInvoiceLine() {
            this.$emit('add-line');
        },
        ImportLinesFromExcel() {
            this.$emit('import-lines');
        },
        openDialogAdditionalInfo() {
            this.showAdditionalInfoDilog = true;
            this.showDiscountReasonError = false;
            this.ret_amount = this.invoice.retention_amount;
            this.ret_concept = this.invoice.retention_concept;
            this.reimbursable_expense_concept = this.invoice.reimbursable_expense_concept;
            if (this.invoice.general_discounts && this.invoice.general_discounts.length) {
                this.discount_reason = this.invoice.general_discounts[0].reason;
                this.discount_amount = this.invoice.general_discounts[0].amount;
                this.checkedGlobalDiscount = true;
            }
            else {
                this.discount_reason = undefined;
                this.discount_amount = undefined;
                this.checkedGlobalDiscount = false;
            }
            if (this.invoice.reimbursable_amounts && this.invoice.reimbursable_amounts.length) {
                this.reimbursable_expense = this.invoice.reimbursable_amounts[0];
            }
            else {
                this.reimbursable_expense = undefined;
            }
        },
        openDialogEditLine(invoice_line, index) {
            this.showEditLineDialog = true;
            this.num_line = index;
            this.line['description'] = invoice_line.description
            this.line['unit_price_without_tax'] = invoice_line.unit_price_without_tax
            this.line['quantity'] = invoice_line.quantity
            this.line['selected_tax'] = invoice_line.selected_tax
            this.line['selected_retention'] = invoice_line.selected_retention
            this.line['selected_tax_event'] = invoice_line.selected_tax_event
        },
        changeInvoiceLine(index) {
            this.invoice_lines[index].description = this.line['description']
            this.invoice_lines[index].unit_price_without_tax = this.line['unit_price_without_tax']
            this.invoice_lines[index].quantity = this.line['quantity']
            this.invoice_lines[index].selected_tax = this.line['selected_tax']
            this.invoice_lines[index].selected_retention = this.line['selected_retention']
            this.invoice_lines[index].selected_tax_event = this.line['selected_tax_event']
            this.$emit('change-line', index);
            this.showEditLineDialog = false;
            this.invoice_line = {};
        },
        openDialogDeleteAllLines() {
            this.$emit('delete-all-lines');
        },
        cancelEditLineChange() {
            this.showEditLineDialog = false;
            this.invoice_line = {};
        },
        cancelChange() {
            this.showAdditionalInfoDilog = false;
            this.showDiscountReasonError = false;
        },
        changeAdditionalInfo() {
            if (this.discount_amount && !this.discount_reason) {
                this.showDiscountReasonError = true;
                return;
            }

            this.invoice.retention_concept = this.ret_concept;
            this.invoice.retention_amount = this.ret_amount;
            this.invoice.reimbursable_expense_concept = this.reimbursable_expense_concept;

            if (this.discount_amount) {
                this.invoice.general_discounts = [new ExtraAmount(this.discount_reason, parseFloat(this.discount_amount))];
            }
            else {
                this.invoice.general_discounts = [];
            }
            if (this.reimbursable_expense) {
                this.invoice.reimbursable_amounts = [parseFloat(this.reimbursable_expense)];
            }
            else {
                this.invoice.reimbursable_amounts = [];
            }

            for (let line of this.invoice_lines) {
                if (this.checkedLineDiscount && (!line.discounts || line.discounts.length == 0)) {
                    line.discounts = [new ExtraAmount('Descuento', 0, 0)]
                }
                else if (!this.checkedLineDiscount)
                    line.discounts = []
            }


            this.$emit('change-additional-info');
            this.showAdditionalInfoDilog = false;
            this.showDiscountReasonError = false;
        },
        tax_change(newRate, index) {
            if (!this.is_mobile) {
                this.invoice_lines[index].selected_tax = newRate;
                this.$emit('change-line', index);
            } else if (this.is_mobile) {
                this.line ={...this.line, selected_tax: newRate}
            }

        },
        tax_event_change(newTaxEvent, index) {
            if (!this.is_mobile) {
                this.invoice_lines[index].selected_tax_event = newTaxEvent;
                this.$emit('change-line', index);
            } else if (this.is_mobile) {
                this.line['selected_tax_event'] = newTaxEvent
            }
        },
        retention_change(newRate, index) {
            if (!this.is_mobile) {
                this.invoice_lines[index].selected_retention = newRate;
                this.$emit('change-line', index);
            } else if (this.is_mobile) {
                this.line['selected_retention'] = newRate
            }
        },
        product_changed(product, index) {
            if (product && product instanceof Product) {
                //list of computed tax values
                let tax_values = this.computed_tax_items.map(item => item.value);
                if(!tax_values.includes(product.selected_tax)){
                    product.selected_tax = tax_values[1];
                }
                if (product.description != this.invoice_lines[index].description && !this.is_mobile) {
                    this.invoice_lines[index].selected_product = product;
                    this.invoice_lines[index].description = product.description;
                    this.$emit('change-line', index);
                } else if (product.description != this.description && this.is_mobile) {
                    this.line['description'] = product.description;
                    this.line['unit_price_without_tax'] = product.price;
                    this.line['selected_tax'] = product.selected_tax;
                    this.line['selected_retention'] = product.selected_retention;
                    if (product.selected_tax == 0.0) {
                        this.line['selected_tax_event'] = product.selected_tax_event;
                    }
                    this.$emit('change-line', index);
                }
            } else {
                if (product != this.invoice_lines[index].description) {
                    this.invoice_lines[index].description = product;
                    let p = this.products.find(p => p.description == product);
                    if (p) {
                        this.invoice_lines[index].selected_product = p;
                    } else {
                        this.invoice_lines[index].selected_product = undefined;
                        this.line['description'] = product
                    }
                    this.$emit('change-line', index);
                }
            }
        },
        openDialogOtherInformation(line) {
            this.actualOtherInformationLine = line;
            if (line.additional_information) {
                this.sender_info = line.additional_information.sender_info;
                this.receiver_info = line.additional_information.receiver_info;
                this.delivery_note_number = line.additional_information.delivery_note_number;
                this.delivery_note_date = line.additional_information.delivery_note_date;
                this.additional_line_information = line.additional_information.additional_line_information;
                this.record_reference = line.additional_information.record_reference;
                this.record_reference_date = line.additional_information.record_reference_date;
            } else {
                this.sender_info = new SenderInfo();
                this.receiver_info = new ReceiverInfo();
                this.delivery_note_number = '';
                this.delivery_note_date = '';
                this.additional_line_information = '';
                this.record_reference = '';
                this.record_reference_date = '';
            }
            this.keyDialog += 1;
            this.otherInformationDialog = true
        },
        chnageOtherInformation() {
            console.log('changeOtherInformation called')
            this.actualOtherInformationLine.additional_information = new AdditionalInformation(this.sender_info,
                                                                                               this.receiver_info,
                                                                                               this.delivery_note_number,
                                                                                               this.delivery_note_date,
                                                                                               this.additional_line_information,
                                                                                               this.record_reference,
                                                                                               this.record_reference_date
                                                                                            );
            let index = this.invoice_lines.indexOf(this.actualOtherInformationLine);
            this.invoice_lines[index].additional_information = this.actualOtherInformationLine.additional_information;
            this.otherInformationDialog = false;
            this.$emit('change-line', index);
        },
        filterProducts(item, queryText) {
            return (item.description.toLowerCase().includes(queryText.toLowerCase()) || item.code.toLowerCase().includes(queryText.toLowerCase()));
        },
        isValidTaxEvent(taxEvent) {
            if (!taxEvent) return false;
            return this.type_0_options.includes(taxEvent);
        },
        getAdditionalFieldValue(invoice_line, fieldKey) {
            if (!invoice_line.additional_fields || !Array.isArray(invoice_line.additional_fields)) {
                return '';
            }
            const field = invoice_line.additional_fields.find(f => f.key === fieldKey);
            if (!field) {
                if (this.readonly) return '-';
                return '';
            }
            return field.value;
        },
        updateAdditionalFieldValue(invoice_line, fieldKey, newValue) {
            if (!invoice_line.additional_fields) {
                invoice_line.additional_fields = [];
            }
            const fieldIndex = invoice_line.additional_fields.findIndex(f => f.key === fieldKey);
            
            if (fieldIndex >= 0) {
                // Update existing field
                invoice_line.additional_fields[fieldIndex].value = newValue;
            } else {
                // Add new field
                const fieldConfig = this.productConfiguration.fields.find(f => f.key === fieldKey);
                if (fieldConfig) {
                    invoice_line.additional_fields.push({
                        key: fieldKey,
                        name: fieldConfig.name,
                        value: newValue
                    });
                }
            }
        }
    },

}
</script>

<style scoped>
.primary-bckground {
    background-color: var(--v-primary-base);
}

.primary-border {
    border-color: #363636 !important;
}

.lines__table {
    font-size: 14px !important;
    width: 100% !important;
    max-height: 270px;
    padding: 0px !important;
    scrollbar-width: thin;
}

.table-head {
    border-color: #363636;
    background-color: #F4F4F4;
    height: 40px !important;
    font-weight: 600;
}

.table-right-head {
    background-color: #F4F4F4;
}

.table-head-row {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #F4F4F4;
    height: 40px !important;
    font-weight: 600;
}

.table-row .col,
.table-row .v-text-field__slot>input {
    padding: 0px;
}

.footer {
    z-index: 101;
    max-height: 100%;
}

.bg__gray {
    background-color: rgba(217, 217, 217, 0.502);
}

.bg__gray__2 {
    background-color: #d9d9d9;
}

.error__msg {
    background-color: #DC0B0B1A !important;
    padding-left: 34px !important;
    border: 2px solid rgba(220, 11, 11, 0.898) !important;
    font-size: 13px;
    font-weight: 400;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}

.primary__blue {
    color: var(--v-primary_blue-base);
}

.prevent-cut {
    word-break: break-word;
    overflow-wrap: break-word;
}

.card__tabs .v-tab.v-tab  {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.41px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.card__tabs .v-tab.v-tab--active, .card__tabs >>> .v-tabs-slider {
    color: var(--v-primary_blue-base) !important;
}

.small_col {
    flex: 0 0 5%;
    max-width: 5%;
}

.more__info__editor__title {
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    height: 70px;
}

.more__info__editor__title span {
    font-size: 20px;
    font-weight: 600;
    font-family: "Roboto";
    line-height: 24px;
    text-transform: capitalize;
    color: var(--v-primary_blue-base);
}
</style>
